/**
 * Renders a JSON-LD block into the page.
 *
 * The static blog generator used to inject this itself, which was one more thing
 * duplicated outside the app. Now that blog pages are React routes rendered to
 * static HTML by scripts/prerender.mjs, the structured data can live in the
 * component and still reach crawlers: the prerenderer captures the DOM after
 * render, so the script tag is in the shipped HTML.
 */
export function JsonLd({ data }: { data: unknown }) {
  return (
    <script
      type="application/ld+json"
      // Our own build-time data, never user input.
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
